module.exports = __webpack_public_path__ + "img/gears_splash.ad5b79fc.jpg";